import { render, staticRenderFns } from "./AtomLink.vue?vue&type=template&id=5b97a300&scoped=true&"
import script from "./AtomLink.vue?vue&type=script&lang=ts&"
export * from "./AtomLink.vue?vue&type=script&lang=ts&"
import style0 from "./AtomLink.vue?vue&type=style&index=0&id=5b97a300&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b97a300",
  null
  
)

export default component.exports